import httpClient from "@/store/httpClient";
import { saveAs } from "file-saver";

export default {
    namespaced: true,
    state: {
        anlagen: undefined,
        documents: undefined,
    },
    mutations: {
        SET_ANLAGEN(state, anlagen) {
            state.anlagen = anlagen;
        },
        SET_DOCUMENTS(state, documents) {
            state.documents = documents;
        }
    },
    getters: {
        latestYear: state => {
            return [...new Set(state.anlagen.map(a => a.Jahr))].toSorted((a, b) => a + b)[0];
        },
        anlagenForLatestYear: (state, getters) => {
            return state.anlagen.filter(a => a.Jahr === getters.latestYear);
        },
        payments: state => {
            function getPaymentsForYear(year) {
                return state.anlagen.filter(a => a.Jahr === year)
                    .map(a => a.VerguetungKommune)
                    .reduce((acc, current) => acc + current, 0);
            }

            const years = [...new Set(state.anlagen.map(a => a.Jahr))].toSorted((a, b) => a - b);

            return years.map(year => {
                return {
                    year,
                    value: getPaymentsForYear(year)
                }
            })
        },
        documentTypes: state => {
            return ["Alle Dokumente", ...new Set(state.documents.map(d => d.dokumenttyp))];
        },
        documentYears: state => {
            return ["Alle Jahre", ...new Set(state.documents.map(d => d.jahr))];
        }
    },
    actions: {
        async loadAnlagen({ commit }) {
            const response = await httpClient.get("/einspeisebeteiligungs/list-anlagen");

            if (response.status !== 200) return;

            await commit("SET_ANLAGEN", response.data);
        },
        async loadDocuments({ commit }) {
            const response = await httpClient.get("/einspeisebeteiligungs/list-documents");

            if (response.status !== 200) return;

            await commit("SET_DOCUMENTS", response.data);
        },
        async downloadFile({state}, id) {
            const response = await httpClient.get(`/enaio/download?id=${id}&type=einspeisebeteiligung`, { responseType: 'blob'});
            if(response.status === 200) {
                const file = state.documents.find(f => f.osid === id);
                const extension = file?.fileProperties.find(f => f.type === 'EXTENSION')?.value ?? 'pdf';
                saveAs(response.data, (file?.titel ?? "download") + '.' + extension);
            }
        },
        async sendContactMail(_, contactForm) {
            await httpClient.post("/einspeisebeteiligungs/send-contact-mail", contactForm);
        }
    }
}
